import HTTP from './http-interceptor';
import { CAMPAIGN } from '../constants';

const CampaignService = {

    getCampaign: async (area) => {
        return HTTP.get(`${CAMPAIGN.ACTIVE}${area}`);
    },
    getCampaignResult: async (area, player) => {
        return HTTP.get(`${CAMPAIGN.ESTADISTICAS}${area}/${player}`);
    },
}

export default CampaignService;